import { AxiosResponse } from 'axios'
import { BaseAPI } from './BaseAPI.js'
import { UserLicenseToken } from '../types/index.js'

export default class UserLicenseTokensAPI extends BaseAPI<UserLicenseToken> {
  override get resource(): string {
    return '/userLicenseTokens'
  }

  public async purchaseNew(
    organizationId: number,
    licenseTypes: { [key: number]: number },
    useCredits = false,
  ): Promise<{ attributes?: { redirectUrl: string } }> {
    const result: AxiosResponse = await this._client.post(
      `userLicenseTokens/purchase`,
      {
        data: {
          type: 'tokens',
          attributes: {
            organizationId,
            useCredits,
            licenseTypes,
          },
        },
      },
    )

    return result.data.data
  }
}
